/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { sigintListSignals } from "../funcs/sigintListSignals.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListSigintSignalsRequest,
  ListSigintSignalsResponse,
  ListSigintSignalsSecurity,
} from "../models/operations/listsigintsignals.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type SigintSignalsQueryData = ListSigintSignalsResponse;

export type SigintSignalsInfiniteQueryData = PageIterator<
  ListSigintSignalsResponse,
  { cursor: string }
>;

export type SigintSignalsPageParams = PageIterator<
  ListSigintSignalsResponse,
  { cursor: string }
>["~next"];

export function prefetchSigintSignals(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSigintSignalsRequest | undefined,
  security?: ListSigintSignalsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSigintSignalsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchSigintSignalsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSigintSignalsRequest | undefined,
  security?: ListSigintSignalsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildSigintSignalsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as SigintSignalsPageParams,
    getNextPageParam: (previousPage: SigintSignalsInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildSigintSignalsQuery(
  client$: GramCore,
  request?: ListSigintSignalsRequest | undefined,
  security?: ListSigintSignalsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<SigintSignalsQueryData>;
} {
  return {
    queryKey: queryKeySigintSignals({
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function sigintSignalsQueryFn(
      ctx,
    ): Promise<SigintSignalsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(sigintListSignals(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildSigintSignalsInfiniteQuery(
  client$: GramCore,
  request?: ListSigintSignalsRequest | undefined,
  security?: ListSigintSignalsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, SigintSignalsPageParams>,
  ) => Promise<SigintSignalsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeySigintSignalsInfinite({
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function sigintSignalsQuery(
      ctx,
    ): Promise<SigintSignalsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(sigintListSignals(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(sigintListSignals(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeySigintSignals(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "sigint", "listSignals", parameters];
}

export function queryKeySigintSignalsInfinite(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "sigint", "listSignals", "infinite", parameters];
}
